import { createReducer, on } from '@ngrx/store';
import { enablePage, loadQueryParameters, enableConfigAPI } from './app-meta.actions';
import { AppMetaInformation } from 'src/app/models/application.interface';
import { ResStatus } from 'src/app/models/config.interface';

export interface AppMetaState {
  metaData: AppMetaInformation;
  status: ResStatus;
  error: string;
}

const initialState: AppMetaState = {
  metaData: {
    disablePage: true,
    stopLoadingSpinner: false,
    noConfigData: false,
    enableConfigAPI: false
  },
  status: 'pending',
  error: ''
};

// Reducers for handling actions
export const appMetaReducer = createReducer(
  initialState,

  on(enablePage, (state, { disablePage, stopLoadingSpinner, noConfigData }) => ({
    ...state,
    metaData: {
      ...state.metaData,
      disablePage: disablePage,
      stopLoadingSpinner: stopLoadingSpinner,
      noConfigData: noConfigData
    },
    status: <ResStatus>'success'
  })),

  on(enableConfigAPI, (state, { enableConfigAPI }) => ({
    ...state,
    metaData: {
      ...state.metaData,
      enableConfigAPI: enableConfigAPI
    },
    status: <ResStatus>'success'
  })),

  on(loadQueryParameters, (state, { user, id, project, key, lng, country, RID }) => {
    return {
      ...state,
      metaData: {
        ...state.metaData,
        user: user.value,
        id: id.value,
        project: project.value,
        key: key.value,
        lng: lng.value,
        country: country.value,
        RID: RID.value
      }
    };
  })
);
